<template>
  <div>
    <q-select
      v-model="color"
      :options="colorOptions"
      emit-value
      map-options
      :option-label="opt => opt.label"
      :option-value="opt => opt.value"
      :color="color"
      dense
      bg-color="white"
      outlined
      class="myFieldSelectColor "
    >
      <template #selected>
        <q-avatar
          :color="color"
          :style=" { backgroundColor: color }"
          size="xs"
        />
      </template>

      <template #option="scope">
        <q-item
          v-bind="scope.itemProps"
          class="row justify-center items-center"
          @click="() => { updateColor(scope.opt.value); scope.toggleOption(scope.opt); }"
          style="min-width: 12px; min-height: 32px; padding: 0px"
          :style="{ border: scope.opt.value === color ? `1px solid ${scope.opt.value}` : '1px solid white' }"
        >
          <q-avatar
            size="xs"
            :color="scope.opt.value"
            :style=" { backgroundColor: scope.opt.value }"
          />
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      color: this.backgroundColor,
      colorOptions: [
        { label: 'Peach', value: '#FFB284' },
        { label: 'Gold', value: '#FFD700' },
        { label: 'Lilac', value: '#B497BD' },
        { label: 'Green', value: '#70E1B5' },
        { label: 'Blue', value: '#7EC8E3' },
        { label: 'Red', value: '#F28C8C' }
      ]
    }
  },

  props: {
    backgroundColor: {
      type: String,
      default: 'blue'
    }
  },
  methods: {
    updateColor (color) {
      this.color = color
      this.$emit('update-color', this.color)
    }
  }
}
</script>

<style lang="sass">
.myFieldSelectColor
  .q-field--outlined .q-field__control
    border-radius: 10px
  .q-field__control
    min-height: 32px !important
    color: #4c8ec5 !important

    .q-field__control-container
      font-style: normal
      font-weight: normal
      font-size: 13px
      line-height: 18px
      color: rgba(38,50,56, 0.9)

    &:hover
      &:before
        border: 1px solid #486e8e !important
        transition: none

    &:after
      border-width: 1px !important

  .q-field__control-container
    padding-top: 1px
    .q-field__native
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      min-height: 32px

  .q-field__marginal
    height: 32px

  .fontChips
    div.ellipsis
      font-style: normal
      font-weight: normal
      font-size: 12px
      margin-right: 5px

  .q-field__native.row.items-center
    padding: 3px 0 4px 0 !important

  .q-chip
    margin-top: 2px !important
    margin-bottom: 2px !important
    margin-left: 0 !important

  .font-item
    font-style: normal
    font-weight: normal
    font-size: 13px
    line-height: 18px
    color: #01253C
  </style>
